import * as MarkerClusterer from '@google/markerclustererplus';

export default {
  init() {
    window.MarkerClusterer = MarkerClusterer;
  },
  finalize() {},
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/hasMap.js